'use client'

import type { QueryClient } from '@tanstack/react-query'

import { clearPersistedQueryCache } from '@/context/queryPersistence'

export async function clearQueryClientAuthStateBestEffort(
  queryClient: QueryClient,
): Promise<void> {
  try {
    await queryClient.cancelQueries(undefined, { silent: true })
  } catch {}

  try {
    queryClient.removeQueries()
  } catch {}

  try {
    queryClient.getMutationCache().clear()
  } catch {}

  try {
    await clearPersistedQueryCache()
  } catch {}
}
